import { ErrorMessage } from "../../enums/error-message";
import { ValidationError } from "../validation-error";
export class ValueValidator {
    validate(trackingObject) {
        if (typeof trackingObject.value === 'undefined')
            return;
        if (typeof trackingObject.value === 'string' || isNaN(trackingObject.value)) {
            throw new ValidationError(ErrorMessage.INVALID_NUMBER);
        }
    }
}
